import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { appendQuery } from '../../shared/utils/commenFunctions';
import {
  StaffCreateRequest,
  StaffDetailResponse,
  StaffListParams,
  StaffListResponse,
  StaffUpdateRequest,
} from '../models/staff.model';

@Injectable({
  providedIn: 'root',
})
export class StaffAdminService {
  private readonly apiService = inject(ApiService);

  listStaff(params: StaffListParams): Observable<StaffListResponse> {
    const queryPayload: Record<string, unknown> = {
      index: params.index,
      limit: params.limit,
      searchText: params.searchText ?? '',
    };

    if (params.status !== null && params.status !== undefined) {
      queryPayload['status'] = params.status;
    }

    if (params.locationId) {
      queryPayload['locationId'] = params.locationId;
    }

    const url = appendQuery(API_ENDPOINTS.ADMIN.STAFF.LIST, queryPayload);
    return this.apiService.get<StaffListResponse>(url);
  }

  getStaff(staffId: string): Observable<StaffDetailResponse> {
    return this.apiService.get<StaffDetailResponse>(API_ENDPOINTS.ADMIN.STAFF.DETAIL(staffId));
  }

  createStaff(request: StaffCreateRequest): Observable<StaffDetailResponse> {
    return this.apiService.post<StaffDetailResponse>(API_ENDPOINTS.ADMIN.STAFF.CREATE, request);
  }

  updateStaff(staffId: string, request: StaffUpdateRequest): Observable<StaffDetailResponse> {
    return this.apiService.put<StaffDetailResponse>(API_ENDPOINTS.ADMIN.STAFF.UPDATE(staffId), request);
  }

  deactivateStaff(staffId: string): Observable<StaffDetailResponse> {
    return this.apiService.delete<StaffDetailResponse>(API_ENDPOINTS.ADMIN.STAFF.DELETE(staffId));
  }
}
